import React from 'react';
import {Link} from 'react-router-dom';

class CartTabs extends React.Component {
    render() {

        const tabs = [
            {name: "Корзина", link: '/cart/', code: 'cart'},
            {name: "Отложенные", link: '/cart/wishlist/', code: 'wishList'},
        ];

        let tabsHTML = [];
        // eslint-disable-next-line
        tabs.map(item => {
            if (this.props[item.code] > 0) {
                const active = (item.code === this.props.activeButton) ? 'is-active' : '';

                tabsHTML.push(
                    <div key={item.code} className={active + " cart-button"}>
                        <Link to={item.link}>{item.name}</Link>
                    </div>
                );
            }
        });

        return (
            <div className="cart-buttons">
                {tabsHTML}
            </div>
        );
    }
}

export default CartTabs;